import { render, staticRenderFns } from "./PPriv_display1.vue?vue&type=template&id=60dad940&scoped=true"
import script from "./PPriv_display1.vue?vue&type=script&lang=js"
export * from "./PPriv_display1.vue?vue&type=script&lang=js"
import style0 from "./PPriv_display1.vue?vue&type=style&index=0&id=60dad940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dad940",
  null
  
)

export default component.exports